<template>
  <div class="Contract">
    <div class="flex-jc-bt main">
      <div class="flex-60 left-side text-left">
        <div style="border: 3px dashed #C3DCE0; box-sizing: border-box" class="pd-20 pd-t-60">
          <div class="content-form flex-jc-start">
            <div class="flex-1">
              <div class="flex-al-center flex-jc-start">
                <div class="pd-r-10 right text-right">
                  <spInput v-model="personel.title"
                           disabled
                           name="title"
                           height="40" required type="gray" />
                </div>
                <div class="flex-1" style="position: relative">
                  <div class="flex-al-center flex-jc-start">
                    <div class="flex-50">
                      <span v-required class="fn-span font16 italic-bold">{{ $l('MyName') }}</span>
                      <spInput v-model="personel.firstName" disabled name="firstName"
                               placeholder="Native Language" row="3" height="40" required type="gray" />
                    </div>
                    <div class="flex-50 pd-l-30">
                      <span v-required class="fn-span font16 italic-bold">{{ $l('CodeName') }}</span>
                      <spInput v-model="personel.codeName" name="codeName" disabled
                               placeholder="English" row="3" height="40" required type="gray" />
                    </div>
                  </div>
                </div>
                <div class="icon-panel" />
              </div>

              <div class="flex-al-center flex-jc-start" style="margin-top: 4px">
                <div class="pd-r-10 right text-right" />
                <div class="flex-1" style="position: relative">
                  <div class="flex-al-center flex-jc-start">
                    <div class="flex-50">
                      <spInput v-model="personel.nativeName" name="nativeName" disabled
                               placeholder="English" row="3" height="40" required type="gray" />
                    </div>
                    <div class="flex-50 pd-l-30" />
                  </div>
                </div>
                <div class="icon-panel" />
              </div>
              <div class="flex-al-center flex-jc-start mg-t-30">
                <div class="pd-r-10 right text-right" />
                <div class="flex-1" style="position: relative">
                  <div class="flex-al-center flex-jc-start">
                    <span v-required class="fn-span font16 italic-bold">{{ $l('FamilyName') }}</span>
                    <div class="flex-50">
                      <spInput v-model="personel.lastName" disabled
                               placeholder="English" row="3" height="40" required type="gray" />
                    </div>
                    <div class="flex-50 pd-l-30" />
                  </div>
                </div>
                <div class="icon-panel" />
              </div>
              <div class="flex-al-center flex-jc-start mg-t-30">
                <div class="pd-r-10 right text-right" />
                <div class="flex-1" style="position: relative">
                  <div class="flex-al-center flex-jc-start">
                    <span v-required class="fn-span font16 italic-bold" style="left: 70px">{{ $l('Country') }}</span>
                    <div class="flex-50">
                      <spInput v-model="personel.country.name" disabled
                               placeholder="English" height="42" type="gray" />
                    </div>
                    <div class="flex-50">
                      <div class="flex-al-center flex-jc-start">
                        <div class="text-center" style="width: 30px;">—</div>
                        <div class="flex-1">
                          <spInput v-model="personel.city.name" disabled
                                   placeholder="English" height="42" type="gray" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="icon-panel" />
              </div>

              <div class="flex-al-center flex-jc-start" style="margin-top: 4px">
                <div class="pd-r-10 right text-right" />
                <div class="flex-1" style="position: relative">
                  <div class="flex-al-center flex-jc-start">
                    <div class="flex-50 text-right">
                      {{ personel.phonecode }}
                    </div>
                    <div class="flex-50">
                      <div class="flex-al-center flex-jc-start">
                        <div class="text-center" style="width: 30px;">—</div>
                        <div class="flex-1">
                          <spInput v-model="personel.cityPhonecode" disabled class="size-8" width="44" height="24" row="3" type="gray" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="icon-panel" />
              </div>
            </div>
            <div style="width: 198px" class="avatar-panel pd-l-30">
              <div class="avatar-select">
                <p class="font16 italic name-label sp-color-18">{{ $l('HeadPortrait') }}</p>
                <SpUploadGroup ref="avatar-upload" max-count="1" width="198" height="240"
                               file-type="user/avatar"
                               disabled
                               :default-files="personel.personelPortrait" />
              </div>
            </div>
          </div>
          <p v-triangle class="font18 head">{{ $l('PrivateInformation') }}</p>
          <div class="content-form flex-jc-start">
            <div class="flex-1">
              <div class="label-content mg-t-20">
                <div class="content flex-al-center flex-jc-start">
                  <div class="label pd-r-10 text-right">
                    <span v-required class="font16 fw-bold italic pd-r-10">{{ $l('MobilePhone') }}</span>
                  </div>
                  <div class="flex-1">
                    <div class="flex-al-center flex-jc-start">
                      <div style="width: 60px;">
                        <spInput v-model="personel.phonecode" width="60" height="42" name="phonecode" type="gray" disabled />
                      </div>
                      <div class="flex-1">
                        <spInput v-model="personel.mobileNo" required height="42" disabled type="gray" />
                      </div>
                    </div>
                  </div>
                  <div class="icon-panel" />
                </div>
              </div>

              <div class="label-content mg-t-20">
                <div class="content flex-al-center flex-jc-start">
                  <div class="label pd-r-10 text-right">
                    <span class="font16 italic">Private</span> &nbsp;<span v-required class="font16 fw-bold italic pd-r-10">{{ $l('EmailAddress') }}</span>
                  </div>
                  <div class="flex-1">
                    <spInput v-model="personel.emails" required height="42" name="emails" type="gray" disabled />
                  </div>
                  <div class="icon-panel" />
                </div>
              </div>
              <div class="label-content" style="margin-top: 4px">
                <div class="content flex-al-center flex-jc-start">
                  <div class="label pd-r-10 text-right">
                    <span class="font16 italic">Private</span> &nbsp;<span class="font16 italic pd-r-10">{{ $l('Skype') }}</span>
                  </div>
                  <div class="flex-1">
                    <spInput v-model="personel.skype" required height="42" name="skype" type="gray" disabled />
                  </div>
                  <div class="icon-panel" />
                </div>
              </div>

              <div class="label-content mg-t-20">
                <div class="content flex-al-center flex-jc-start">
                  <div class="label pd-r-10 text-right">
                    <span class="font16 italic">Private</span> &nbsp;<span class="font16 italic pd-r-10">{{ $l('Yahoo') }}</span>
                  </div>
                  <div class="flex-1">
                    <spInput v-model="personel.yahoo" required height="42" name="yahoo" type="gray" disabled />
                  </div>
                  <div class="icon-panel" />
                </div>
              </div>
              <div class="label-content" style="margin-top: 4px">
                <div class="content flex-al-center flex-jc-start">
                  <div class="label pd-r-10 text-right">
                    <span class="font16 italic">Private</span> &nbsp;<span class="font16 italic pd-r-10">{{ $l('WhatsApp') }}</span>
                  </div>
                  <div class="flex-1">
                    <spInput v-model="personel.whatsapp" required height="42" name="whatsapp" type="gray" disabled />
                  </div>
                  <div class="icon-panel" />
                </div>
              </div>

              <div class="label-content mg-t-20">
                <div class="content flex-al-center flex-jc-start">
                  <div class="label pd-r-10 text-right">
                    <span class="font16 italic">Private</span> &nbsp;<span class="font16 italic pd-r-10">{{ $l('WeChat') }}</span>
                  </div>
                  <div class="flex-1">
                    <spInput v-model="personel.wechat" required height="42" name="wechat" type="gray" disabled />
                  </div>
                  <div class="icon-panel" />
                </div>
              </div>
              <div class="label-content" style="margin-top: 4px">
                <div class="content flex-al-center flex-jc-start">
                  <div class="label pd-r-10 text-right">
                    <span class="font16 italic">Private</span> &nbsp;<span class="font16 italic pd-r-10">{{ $l('QQ') }}</span>
                  </div>
                  <div class="flex-1">
                    <spInput v-model="personel.qq" required height="42" name="qq" type="gray" disabled />
                  </div>
                  <div class="icon-panel" />
                </div>
              </div>

              <div class="label-content" style="margin-top: 4px">
                <div class="content flex-al-center flex-jc-start">
                  <div class="label pd-r-10 text-right" />
                  <div class="flex-1">
                    <p class="fw-bold">{{ $l('OtherContacts') }}</p>
                    <sp-input v-model="personel.otherContacts" name="otherContacts" rows="4" text-type="textarea" type="gray" disabled />
                  </div>
                  <div class="icon-panel" />
                </div>
              </div>
            </div>
            <div style="width: 198px" class="avatar-panel pd-l-30" />
          </div>
          <div class="content-form flex-jc-start">
            <div class="flex-1">
              <div class="font18 mg-b-10 mg-t-60" style="font-weight: 600">{{ $l('departmentInfo') }}</div>
              <div style="width: 200px; box-sizing: border-box" class="pd-r-10 sp-color-18 text-right">
                <div class="font12">{{ personel.lastName }}</div>
                <div class="font12 mg-t-10">{{ personel.firstName }}</div>
                <div class="font12 mg-t-10">{{ personel.city?.name }} <i v-if="personel.city?.name">,</i> {{ personel.country?.name }}</div>
                <!--                <div class="font12 mg-t-10">{{ personel.city?.name }}</div> -->
                <div class="font12 mg-t-20">Mob:{{ personel.phonecode }} &nbsp; {{ personel.mobileNo }}</div>
                <div class="font12 mg-t-10">Skype: {{ personel.skype ? personel.skype : 'NIL' }}</div>
                <div class="font12 mg-t-10">E-Mail:{{ personel.emails.length > 0 ? personel.emails[0]: '' }}</div>
                <div v-if="personel.emails.length > 1" class="font12 mg-t-10">
                  <p v-for=" em in personel.emails.slice(1)">
                    {{ em }}
                  </p>
                </div>

                <img v-if="personel?.personelPortrait[0]?.url" class="calling-item-img mg-t-10" :src="personel?.personelPortrait[0]?.url">
              </div>
              <div style="width: 305px" class="avatar-panel pd-l-30" />
            </div>
          </div>
        </div>
      </div>
      <div class="flex-38 right-side">
        <div class="main text-left">
          <p class="fw-bold italic" style="margin: 0; position:relative; top: 4px; z-index: 99">{{ $l('PersonelSerialNo') }}</p>
          <div class="flex-jc-bt">
            <sp-input v-model="personel.serialNo" name="serialNo" class="flex-70" type="gray" disabled />
            <!--            <sp-input name="codeName" class="flex-25" type="warn" /> -->
          </div>
        </div>
        <div class="main text-left">
          <p class="font18 opacity-90 sp-color-11">{{ $l('SomeSupportingFilesPicturesPDForOthers') }}</p>
          <p class="font16 mg-t-30 opacity-70 sp-color" style="margin-bottom: 0">{{ $l('Relevant certificates') }}</p>
          <div class="uploadFile">
            <SpUploadGroup ref="useCcert" file-type="user/cert"
                           :default-files="userCert"
                           disabled />
          </div>

          <p class="font16 mg-t-30 opacity-70 sp-color" style="margin-bottom: 0">{{ $l('Others') }}</p>
          <div class="uploadFile">
            <SpUploadGroup ref="userOtherPic" file-type="user/other/pic"
                           disabled
                           :default-files="userOtherPic"
            />
          </div>
          <p class="font16 mg-t-30 opacity-70 sp-color" style="margin-bottom: 0">{{ $l('WordExcelFiles') }}</p>
          <div class="uploadFile">
            <SpUpload
              style="margin-left: -20px; "
              disabled
              file-type="user/other/file"
              :default-files="userOtherFile"
              type="primary" />
          </div>
          <p class="font16 mg-t-30 opacity-70 sp-color" style="margin-bottom: 0">{{ $l('PosttheResumePictures') }}</p>
          <div class="uploadFile">
            <SpUploadGroup ref="userResume" file-type="user/resume"
                           :default-files="userResume"
                           disabled />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import spInput from '@/components/common/SpInput'
import spIcon from '@/components/common/SpIcon'
import spCard from '@/components/common/SpCard'
import spButton from '@/components/common/SpButton'
import SpCallingCard from '@/components/common/SpCallingCard'
import SpSelect from '@/components/common/SpSelect'
import SpSelectOption from '@/components/common/SpSelectOption'
import SpUploadGroup from '@/components/common/SpUploadGroup'
import SpUpload from '@/components/common/SpUpload'
import { getCountrySpareList, getUserTitle, searchAddress } from '@/request/APIs/common'
import { formatFiles } from '@/utils/convert'
export default {
  name: 'Contract',
  nameSpace: 'natural.personalProfile.Contract',
  components: {
    SpCallingCard,
    spInput,
    spIcon,
    spCard,
    spButton,
    SpSelect,
    SpSelectOption,
    SpUploadGroup,
    SpUpload
  },

  props: {
    personel: {
      type: Object,
      default: {}
    }
  },

  data () {
    return {
      departmentInfo: {
        fullName: 'Qian An',
        familyName: 'Zhong',
        city: 'Singapore',
        country: 'Singapore',
        phone: '833770101'
      },

      userTitle: [],
      codeNameInfo: {
        lastName: '',
        firstName: '',
        codeName: ''
      },

      countryId: '',
      countrys: [],

      citys: []
    }
  },

  computed: {
    userCert () {
      return formatFiles(this.personel, 'certificates')
    },

    userOtherPic () {
      return formatFiles(this.personel, 'otherPics')
    },

    userOtherFile () {
      const list = []
      if (this.personel.otherFiles?.files) {
        const files = this.personel.otherFiles?.files
        Object.keys(files).forEach(key => {
          // 后缀获取
          let suffix = ''
          // 获取类型结果
          let result = ''
          try {
            const flieArr = files[key].split('.')
            suffix = flieArr[flieArr.length - 1]
          } catch (err) {
            suffix = ''
          }
          // fileName无后缀返回 false
          if (!suffix) {
            result = false
            return result
          }

          list.push({
            type: suffix,
            url: files[key],
            id: key,
            name: key
          })
        })
      }
      return list
    },

    userResume () {
      return formatFiles(this.personel, 'resume')
    }
  },

  watch: {
  },

  created () {

  },

  mounted () {
  },

  methods: {

  }
}
</script>

<style scoped lang="less">
.calling-item-img{
  vertical-align: middle;
  object-fit: contain ;
  max-width: 60px;
  // max-height:100%;
}
.Contract{
  .uploadFile{
    position: relative;
    top: -4px;
  }
  .label-content{
    .label{
      width: 200px;
    }
  }
  .left-side{
    .contract-info-input{
      //pd-b-40 pd-l-20 pd-t-20
      padding: @gap 0 @gap*2 @gap;
      // min-width: 860px;
    }
  }
  .right-side{
    background-color: white;
    .main,.department-info{
      padding: @gap @gap @gap @gap*2;
    }
    .department-info{
      .info-detail{
        .item{
          width:100%;
          -webkit-display:flex;
          -ms-display:flex;
          display:flex;
          justify-content: space-between;
          -webkit-justify-content: space-between;
          -ms-justify-content: space-between;
          vertical-align: text-top;
          line-height: 1em;
          p{
            margin: @gap/5 0 @gap/5 0;
            font-size: 12px;
          }
          .left{
            flex:0 0 30%;
            text-align: right;
          }
          .right{
            flex:0 0 65%;
            text-align: left;
            opacity: 0.6;
          }
        }
      }
    }
  }
  .tip{
    opacity: 0.6;
    font-size: 12px;
    margin: 0 0 @gap/2 0;
  }
}
.icon-panel {
  padding-left: 10px;
  .iconfont {
    font-size: 22px;
  }
}
.fn-span{
  position: absolute;
  top: -14px;
  color: #000000;
  opacity: 0.8;
  z-index: 99;
}
.content-form{
  .right{
    width: 139px;
  }
  .icon-panel{
    width: 32px;
    box-sizing: border-box;
  }
}
.avatar-panel {
  position: relative;
  top: -14px;
  .name-label {
    margin: 0;
  }
  .avatar-uploader{
    width: 198px;
    height: 240px;
    position: absolute;
    top: 14px;
  }
}
</style>

<style lang="less">
.cus-disabled-choose{
  .SpChoose{
    &[disabled='true']{
      label{
        .label{
          opacity: 1;
        }
      }
    }
  }
}
.SpInput{
  &.size-8{
    input {
      font-size: 8px;
    }
  }
}
</style>
